import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  ViewListingNoInformation: {
    id: 'ViewListingNoInformation',
    defaultMessage: 'No information',
  },
});
